import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'dayjsFormat',
  standalone: true,
})
export class DayjsFormatPipe implements PipeTransform {
  transform(
    value: string | Date | dayjs.Dayjs,
    format:
      | 'date'
      | 'time'
      | 'dateTime'
      | 'dateWithWeekday'
      | 'dateTimeWithWeekday'
      | 'dateWithAbbrWeekday'
      | 'dateTimeWithAbbrWeekday'
      | string = 'date'
  ): string {
    if (!value) {
      return '';
    }

    let formatPattern;
    switch (format) {
      case 'date':
        formatPattern = 'DD.MM.YYYY';
        break;
      case 'time':
        formatPattern = 'HH:mm';
        break;
      case 'dateTime':
        formatPattern = 'DD.MM.YYYY, HH:mm';
        break;
      case 'dateWithWeekday':
        formatPattern = 'dddd, DD.MM.YYYY';
        break;
      case 'dateTimeWithWeekday':
        formatPattern = 'dddd, DD.MM.YYYY, HH:mm';
        break;
      case 'dateWithAbbrWeekday':
        formatPattern = 'dd. DD.MM.YYYY';
        break;
      case 'dateTimeWithAbbrWeekday':
        formatPattern = 'dd. DD.MM.YYYY, HH:mm';
        break;
      default:
        formatPattern = format ?? 'DD.MM.YYYY';
    }
    return dayjs(value).format(formatPattern);
  }
}
